import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'

export const CLIENT_HEADER = {
	USER_AGENT: 'userAgent',
	TIMEZONE: 'timezone',
	LANGUAGE: 'language'
} as const

const headerResolvers = {
	[CLIENT_HEADER.USER_AGENT]: () => ['X-Client-User-Agent', navigator.userAgent],
	[CLIENT_HEADER.TIMEZONE]: () => ['X-Client-Timezone', Intl.DateTimeFormat().resolvedOptions().timeZone],
	[CLIENT_HEADER.LANGUAGE]: () => ['X-Client-Language', navigator.language]
} as const

type HeaderKey = (typeof CLIENT_HEADER)[keyof typeof CLIENT_HEADER]

export const clientHeaders = () => {
	const entries: [string, string][] = []
	const builder = {
		with(key: HeaderKey) {
			entries.push(headerResolvers[key]() as [string, string])
			return builder
		},
		build: () => Object.fromEntries(entries)
	}
	return builder
}

const call = async (method: string, url: string, config: AxiosRequestConfig) => {
	const response: AxiosResponse = await axios.request({
		method,
		url,
		withCredentials: true,
		...config
	})
	return response.data
}

export default {
	async get(path: string, params?: Record<string, string>) {
		return await call('get', path, {
			params
		})
	},
	async post(path: string, data: Record<string, string>, headers?: Record<string, string>) {
		return await call('post', path, {
			data,
			headers
		})
	}
}
